import { render, staticRenderFns } from "./recovered-case.vue?vue&type=template&id=01d6509e"
import script from "./recovered-case.vue?vue&type=script&lang=ts"
export * from "./recovered-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports